<template>
  <section class="section clients">
    <div class="clients__go-to">
      <a class="button-round button-round_green" v-scrollTo="'header'">
        <img src="../../assets/images/chevron.svg" alt="">
      </a>
    </div>
    <div class="section__container clients__container">
      <h2 class="section__title clients__title">Наши клиенты</h2>
      <v-carousel class="clients__carousel" :show-arrows="false">
        <v-carousel-item>
          <img class="pc" src="./assets/pc_1.png" alt="Наши клиенты">
          <img class="mb" src="./assets/mb_1.jpg" alt="Наши клиенты">
        </v-carousel-item>
        <v-carousel-item>
          <img class="pc" src="./assets/pc_2.png" alt="Наши клиенты">
          <img class="mb" src="./assets/mb_2.jpg" alt="Наши клиенты">
        </v-carousel-item>
        <v-carousel-item>
          <img class="pc" src="./assets/pc_3.png" alt="Наши клиенты">
          <img class="mb" src="./assets/mb_3.jpg" alt="Наши клиенты">
        </v-carousel-item>
      </v-carousel>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Clients'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
